module.exports = __webpack_public_path__ + "img/idx-game-bg2.ce3489b.webp";